import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionsKey } from '../../utils/keys';
export const useCreateCollection = (options) => {
    const { useMutationOptions, fields } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const collectionsKey = getCollectionsKey();
    return useMutation((input) => client.collections.create(input, fields), {
        onSuccess: async (_) => {
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCreateCollection.js.map